module.exports = __webpack_public_path__ + "img/Logowall-before.33c25f98.png";